import { FC } from "react";
import styled from "styled-components";
import Colors from "../../../ui/global/Colors";
import Fonts from "../../../ui/global/Fonts";

const FramesContainer = styled.div.attrs<{ $isMobile?: boolean }>(props => ({
    style: {
        justifyContent: props.$isMobile ? 'flex-start' : 'flex-end',
        width: props.$isMobile ? '100%' : 'fit-content',
        margin: props.$isMobile ? '0 auto 0 7px' : '0 7px 0 auto',
    },
}))<{ $isMobile?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    // gap: 0;
    gap: 5px;
`;

const FramesLabelContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: fit-content;
    // min-width: 56px;
    // max-width: 56px;
    gap: 4.5px;
`;

const BoldText = styled.p`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-family: ${Fonts.lexendBold.fontFamily};
    font-weight: ${Fonts.lexendBold.fontWeight};
    font-size: 13px;
    line-height: 1.2em;
    text-align: right;
    text-wrap: nowrap;
    color: ${Colors.grey6};
    margin: auto 0 auto 0;
`;

const SemiBoldText = styled.p`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-family: ${Fonts.lexendSemiBold.fontFamily};
    font-weight: ${Fonts.lexendSemiBold.fontWeight};
    font-size: 13px;
    line-height: 1.2em;
    text-align: right;
    text-wrap: nowrap;
    color: ${Colors.grey6};
    margin: auto 0 auto 0;
`;

const SemiLightText = styled.p`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-family: ${Fonts.lexendSemiLight.fontFamily};
    font-weight: ${Fonts.lexendSemiLight.fontWeight};
    font-size: 13px;
    line-height: 1.2em;
    text-align: right;
    text-wrap: nowrap;
    color: ${Colors.grey7};
    margin: auto 0 auto 0;
`;

interface LabelFramesProps {
    currentFrameNumber: number;
    maxFrames: number;
    isMobile?: boolean;
}

const LabelFrames: FC<LabelFramesProps> = ({
    currentFrameNumber,
    maxFrames,
    isMobile,
}) => {
    if (maxFrames === 0) {
        return (
            <FramesContainer>
                <SemiLightText>{' '}</SemiLightText>
            </FramesContainer>
        )
    }

    return (
        <FramesContainer $isMobile={isMobile}>
            <SemiBoldText>{"FRAME"}</SemiBoldText>
            
            <FramesLabelContainer>
                <SemiBoldText>{currentFrameNumber.toString()}</SemiBoldText>
                <SemiBoldText>{"of " + maxFrames.toString()}</SemiBoldText>
                {/* <BoldText>{currentFrameNumber.toString()}</BoldText> */}
                {/* <SemiLightText>{"of " + maxFrames.toString()}</SemiLightText> */}
            </FramesLabelContainer>
        </FramesContainer>
    );
};

export default LabelFrames;